import { StructureMemberState } from 'domain/structureMember/StructureMemberState';
import { UserView } from 'domain/user/UserView';

import { RoleStructure } from '../roleStructure/RoleStructure';
import { Structure } from '../structure/Structure';

export interface StructureMemberFilters {
  idPlayer?: string;
  idStructure?: string;
  state?: StructureMemberState;
  asMember?: boolean;
}
export class StructureMember {
  constructor(
    public readonly user: UserView,
    public readonly role: RoleStructure,
    public readonly state: StructureMemberState,
    public readonly structure?: Structure,
  ) {}
}
